import { GridDetailRowProps } from '@progress/kendo-react-grid';
import Table from '../../../../components/stateful/table/Table';
import { useAppUserManagementController } from './AppUserManagementController';
import CustomButton from '../../../../components/stateless/customButton/CustomButton';
import EditAppUserRolesModal from './editAppUserRolesModal.tsx/EditAppUserRolesModal';

function AppUserManagement() {
  const {
    // state
    columnData,
    selectedAppUser,
    appUsersValues,
    fetchingAppUsers,
    openRolesModal,
    openTitlesModal,
    currentRoles,
    availableRoles,
      currentTitles,
      availableTitles,
    // functions
    openAppUserRolesModal,
    openAppUserTitlesModal,
    removeUserTitle,
    addUserTitle,
    makeTitleName,
    // toggleRolesViewModal,
    toggleRolesModal,
    toggleTitlesModal,
    getAppUserDetails,
    removeAppUserRole,
    addAppUserRole,
    // updateUserStatus,
  } = useAppUserManagementController();

  const detailComponent = (detailProps: GridDetailRowProps) => {
    const dataItem = detailProps.dataItem;
    return (
      <div className='appUser-detail-panel'>
        <b>
          Actions for: {dataItem.givenName} {dataItem.username}
        </b>
        <CustomButton
          fillMode='outline'
          icon='hyperlink-open'
          themeColor='primary'
          onClick={(event) => openAppUserTitlesModal(event, dataItem)}
        >
          Edit Titles
        </CustomButton>
        <CustomButton
          fillMode='outline'
          icon='hyperlink-open'
          themeColor='success'
          onClick={(event) => openAppUserRolesModal(event, dataItem)}
        >
          Edit Roles
        </CustomButton>
      </div>
    );
  };

  const onDetailExpand = (dataItem: any) => {
    getAppUserDetails(dataItem);
  };

  const renderAppUserTable = () => {
    return (
      <>
        {columnData ? (
          <Table
            values={appUsersValues}
            columns={columnData}
            tableName={''}
            height={'90vh'}
            details={detailComponent}
            onDetailExpandChange ={onDetailExpand}
            isLoading={fetchingAppUsers}            dataItemKey="id"          />
        ) : null}
      </>
    );
  };

  const renderAppUserRolesModal = () => {
    return (
      <EditAppUserRolesModal
        appUser={selectedAppUser}
        open={openRolesModal}
        toggleDialog={toggleRolesModal}
        title={selectedAppUser?.username}
        createFunction={addAppUserRole}
        deleteFunction={removeAppUserRole}
        columnHeader={["Role Name", "Action"]}
        currentColumnData={currentRoles}
        availableColumnData={availableRoles}
        type={'Roles'}
      />
    );
  };

  const renderAppUserTitlesModal = () => {

    return (
        <EditAppUserRolesModal
            appUser={selectedAppUser}
            open={openTitlesModal}
            toggleDialog={toggleTitlesModal}
            title={selectedAppUser?.username}
            createFunction={addUserTitle}
            deleteFunction={removeUserTitle}
            columnHeader={["Title", "Action"]}
            currentColumnData={
              makeTitleName(currentTitles)}
            availableColumnData={
              makeTitleName(availableTitles)}
            type={'Titles'}
        />
    );
  };

  return (
    <>
      {openRolesModal ? renderAppUserRolesModal() : null}
      {openTitlesModal ? renderAppUserTitlesModal() : null}
      {renderAppUserTable()}
    </>
  );
}

export default AppUserManagement;
